<template>
	<div class="barcode">
		<input
			v-model="input"
			ref="input"
			@keyup.enter="enter">

		<v-dialog
			:value="showDialogError"
			persistent
			max-width="320">
			<section class="farme-dialog">
				<header class="farme-dialog-header white--text " style="background: #E50000;">
					Atenção
				</header>

				<main class="farme-dialog-body">
					<p class="font-weight-bold">Medicamento não encontrado na assinatura ou pausado!</p>
					<p>Por favor, certifique-se que este produto não esteja na cesta do picking.</p>
				</main>

				<footer class="farme-dialog-footer">
					<v-spacer></v-spacer>
					<v-btn color="" flat @click="close">Fechar</v-btn>
				</footer>
			</section>
		</v-dialog>
	</div>
</template>

<script>
import axios from 'axios';
import { getCurrentCompanyUnit } from '@Config/unidades';

export default {
	name: 'InputCodigoBarras',
	props: {
		label: {
			type: String
		},
		withoutLabel: {
			type: Boolean
		},
		focusEnabled: {
			required: false,
			type: Boolean,
			default: false
		},
		labelIsRequired: {
			required: false,
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		input: ''
	}),
	mounted() {
		if (this.focusEnabled)
			this.inputFocus();
	},
	watch: {
		focusEnabled(value) {
			if (value)
				this.inputFocus();
		}
	},
	computed: {
		cidade() {
			return getCurrentCompanyUnit().nome;
		},
		showDialogError() {
			return this.$store.state.bipe.is_medicine_pause_or_not_found;
		}
	},
	methods: {
		close() {
			this.$store.commit('bipe/SET_MEDICINE_PAUSED_OR_NOT_FOUND', false);
		},
		inputFocus() {
			if (this.$refs.input)
				this.$refs.input.focus();
		},
		enter() {
			if (this.labelIsRequired && !this.label) {
				this.$store.dispatch('SHOW_SNACKBAR',
					{ message: 'Preencha a etiqueta', color: 'error' });
				return;
			}

			if (!this.withoutLabel && !this.label) {
				this.$store.dispatch('SHOW_SNACKBAR',
					{ message: 'Preencha a etiqueta ou marque a opção "Este medicamento não tem etiqueta"', color: 'error' });
				return;
			}

			if (this.input) {
				this.$emit('productPicked', this.input);
				this.input = '';
				// this.inputFocus();
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.barcode {
	border-radius: 10px;
	background: url("../../processo/picking/dialog-bipe/barcode.png");

	input {
		text-align: center;
		font-weight: 900;
		font-size: 24px;
		letter-spacing: 1px;
		height: 60px;
		outline: none;
		width: 100%;
	}
}
</style>
